export type Environment = 'dev' | 'qa' | 'uat' | 'dr' | 'drn' | 'prod';

/**
 * Detect environment from URL hostname
 */
export function detectEnvironmentFromUrl(): Environment {
  const hostname = globalThis.location.hostname

  if (hostname.includes('dev') || hostname.includes('127.0.0.1') || hostname.includes('localhost')) {
    return 'dev';
  } else if (hostname.includes('qa')) {
    return 'qa';
    } else if (hostname.includes('uat')) {
      return 'uat';
    } else if (hostname.includes('drn')) {
      return 'drn';
    } else if (hostname.includes('dr')) {
      return 'dr';
    } else if (hostname.includes('prod')) {
      return 'prod';
    } 

  // Default fallback
  return 'prod'
}

/**
 * Get config based on detected environment
 *
 * OAuth endpoint mapping from documentation:
 * - "issuer" → not directly used
 * - "authorization_endpoint" → authUrl
 * - "token_endpoint" → tokenUrl
 * - "revocation_endpoint" → revokeUrl
 * - "userinfo_endpoint" → userInfoUrl
 * - "jwks_uri" → jwksUrl
 * - "introspection_endpoint" → not used
 * - "registration_endpoint" → not used
 */
export function getEnvironmentConfig() {
  const env = detectEnvironmentFromUrl()

  const configs = {
    dev: {
      env: 'dev',
      clientId: 'TORT-OAuth-UAT-APP1580', // Update with actual client ID
      apiBaseUrl:
         'https://apiservice-bus-dev.kp.org/api/ds/dcaq/naitortbff/v1r',  // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam-uat.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam-uat.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam-uat.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam-uat.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam-uat.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam-uat.kp.org/idp/startSLO.ping',
      logLevel: 'DEBUG',
      kpAtlasId: 'APP-1580',
    },
    qa: {
      env: 'qa',
      clientId: 'TORT-OAuth-UAT-APP1580', // Update with actual client ID
      apiBaseUrl: 'https://qa-tortbff-bff-1.naitt.aksnp.azure.kp.org', // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam-uat.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam-uat.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam-uat.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam-uat.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam-uat.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam-uat.kp.org/idp/startSLO.ping',
      logLevel: 'ERROR',
      kpAtlasId: 'APP-1580',
    },
    uat: {
      env: 'uat',
      clientId: 'TORT-OAuth-UAT-APP1580', // Update with actual client ID
      apiBaseUrl: 'https://apiservice-bus-uat.kp.org/api/ds/dcaq/naitortbff/v1r', // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam-uat.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam-uat.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam-uat.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam-uat.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam-uat.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam-uat.kp.org/idp/startSLO.ping',
      logLevel: 'ERROR',
      kpAtlasId: 'APP-1580',
    },
    drn: {
      env: "drn",
      clientId: 'TORT-OAuth-UAT-APP1580', // Update with actual client ID
      apiBaseUrl: 'https://apiservice-bus-uat.kp.org/api/ds/dcaq/naitortbff/v1r', // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam-uat.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam-uat.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam-uat.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam-uat.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam-uat.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam-uat.kp.org/idp/startSLO.ping',
      logLevel: 'ERROR',
      kpAtlasId: 'APP-1580',
    },
    prod: {
      env: 'prod',
      clientId: 'TORT-OAuth-PROD-APP1580', // Update with actual client ID
      apiBaseUrl: 'https://apiservice-bus-01.kp.org/api/ds/dcaq/naitortbff/v1r', // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam.kp.org/idp/startSLO.ping',
      logLevel: 'ERROR',
      kpAtlasId: 'APP-1580',
    },
      dr: {
      env: "dr",
      clientId: 'TORT-OAuth-PROD-APP1580', // Update with actual client ID
      apiBaseUrl: 'https://apiservice-bus-01.kp.org/api/ds/dcaq/naitortbff/v1r', // Update with actual API base URL
      HRConnectUrl: 'https://mykp.kp.org/en/hr/time/timeoff/my-time-off-benefits.html',
      TortSharePointUrl: 'https://sp-cloud.kp.org/sites/Tort',
      TortKpLearnUrl: 'https://learn.kp.org/',
      TimeOffPoliciesUrl: 'https://mykp.kp.org/en/hr/work-at-kp/compliance/hr-policies/policies.html',
      authUrl: 'https://fam.kp.org/as/authorization.oauth2',
      tokenUrl: 'https://fam.kp.org/as/token.oauth2',
      revokeUrl: 'https://fam.kp.org/as/revoke_token.oauth2',
      userInfoUrl: 'https://fam.kp.org/idp/userinfo.openid',
      jwksUrl: 'https://fam.kp.org/pf/JWKS',
      endSessionUrl: 'https://fam.kp.org/idp/startSLO.ping',
      logLevel: 'ERROR',
      kpAtlasId: 'APP-1580',
    },
  };
  return configs[env]
}

/**
 * Get client ID for current environment
 */
export function getClientId(): string {
  return getEnvironmentConfig().clientId
}
